<template lang="pug">
  div
    ods-dialog(
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width='40%'
      :append-to-body="true"
      :before-close="close"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :show-close="true")
      span(v-if="data && data.registros")
        imagen-cupon(:data="data.registros" :imagen="data.registros.imagen")
      span(slot='footer')
        ods-button(@click="close") {{ $t('close') }}
</template>

<script>
import ImagenCupon from '@/components/loyalty/Coupons/ImagenCupon'

export default {
  name: 'CouponPreview',
  props: ['data'],
  components: {
    'imagen-cupon': ImagenCupon
  },
  data () {
    return {
      dialogVisible: true
    }
  },
  methods: {
    close () {
      this.dialogVisible = !this.dialogVisible
    }
  }

}
</script>

<style lang="scss">

</style>
